// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "personalInfoSection--u95V";
var _4 = "input-IEl5g";
var _5 = "grid-1rYsd";
export { _1 as "__esModule", _2 as "mobile", _3 as "personalInfoSection", _4 as "input", _5 as "grid" }
export default { "__esModule": _1, "mobile": _2, "personalInfoSection": _3, "input": _4, "grid": _5 }
